import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import base_url from '../config/Config';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import Cookies from 'js-cookie';

const ViewProduct = () => {
    const [loanDetails, setLoanDetails] = useState(null);
    const [updatedLoan, setUpdatedLoan] = useState({});
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const loanId = params.get('loanId');
    const token = Cookies.get('authToken');
    const [permissions, setPermissions] = useState([]);


     useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]));
    }, []);

    // Permission check helper
    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete; // using canDelete for download
            default: return false;
        }
    }, [permissions]);

    const fetchLoanDetails = useCallback(async () => {
        if (!hasPermission('Product', 'view')) return;
        try {
            const { data } = await axios.get(`${base_url}/api/product/viewById?id=${loanId}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });
            setLoanDetails(data);
        } catch (err) {
            console.error("Error fetching loan details:", err);
        }
    }, [loanId, token, hasPermission]);

    useEffect(() => {
        if (!loanId) return;
        fetchLoanDetails();
    }, [fetchLoanDetails, loanId]);

    useEffect(() => {
        if (loanDetails) {
            setUpdatedLoan({
                id: loanDetails.id,
                productName: loanDetails.productName || '',
                interestRate: loanDetails.interestRate || '',
                interestRateType: loanDetails.interestRateType || '',
                processFee: loanDetails.processFee || '',
                otherDeduction: loanDetails.otherDeduction || '',
                loanAmount: loanDetails.loanAmount || '',
                tenureInDays: loanDetails.tenureInDays || '',
                repaymentType: loanDetails.repaymentType || '',
                numberOfEmi: loanDetails.numberOfEmi || '',
                productType: loanDetails.productType || ''
            });
        }
    }, [loanDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedLoan(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleUpdate = async () => {
        if (!hasPermission('Product', 'view')) return;
        try {
            await axios.put(`${base_url}/api/product/updateLoan`, updatedLoan, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });
            alert('Loan updated successfully!');
            fetchLoanDetails();
        } catch (err) {
            console.error("Error updating loan:", err);
            alert('Failed to update loan.');
        }
    };

    
     if (!hasPermission('Product', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return (
        <>
            <div className='overviewsaa'>
                <h4>Loan View</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='reportsanalyzier mb-3'>
                                        <div className='row'>
                                            <div className='col-lg-2 col-md-2'><div className='credit buttonandly'></div></div>
                                            <div className='col-lg-2 col-md-2'><div className='analyzier buttonandly'></div></div>
                                            <div className='col-lg-3 col-md-3'><div className='devicehistory buttonandly'></div></div>
                                            <div className='col-lg-3 col-md-3'><div className='location buttonandly'></div></div>
                                            <div className='col-lg-2 col-md-2'><div className='businessverification buttonandly'></div></div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className='col-md-12 col-lg-12 '>
                                    <div className='personalhead text-justify'></div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="productName">Product Name</label><br />
                                                        <input type="text" name="productName" id="productName" value={updatedLoan.productName || ''} onChange={handleChange} placeholder='Product Name' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="loanAmount">Loan Amount</label><br />
                                                        <input type="number" name="loanAmount" id="loanAmount" value={updatedLoan.loanAmount || ''} onChange={handleChange} placeholder='Loan Amount' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="interestRate">ROI</label><br />
                                                        <input type="text" name="interestRate" id="interestRate" value={updatedLoan.interestRate || ''} onChange={handleChange} placeholder='ROI' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="interestRateType">ROI Type</label><br />
                                                        <input type="text" name="interestRateType" id="interestRateType" value={updatedLoan.interestRateType || ''} onChange={handleChange} placeholder='ROI Type' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="processFee">Processing Fee</label><br />
                                                        <input type="number" name="processFee" id="processFee" value={updatedLoan.processFee || ''} onChange={handleChange} placeholder='Processing Fee' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="otherDeduction">Other Deduction</label><br />
                                                        <input type="number" name="otherDeduction" id="otherDeduction" value={updatedLoan.otherDeduction || ''} onChange={handleChange} placeholder='Other Deduction' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="tenureInDays">Tenure</label><br />
                                                        <input type="number" name="tenureInDays" id="tenureInDays" value={updatedLoan.tenureInDays || ''} onChange={handleChange} placeholder='Tenure In Days' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="numberOfEmi">Number of EMI</label><br />
                                                        <input type="number" name="numberOfEmi" id="numberOfEmi" value={updatedLoan.numberOfEmi || ''} onChange={handleChange} placeholder='Number of EMI' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="repaymentType">Repayment Type</label><br />
                                                        <input type="number" name="repaymentType" id="repaymentType" value={updatedLoan.repaymentType || ''} onChange={handleChange} placeholder='Repayment Type' />
                                                    </div>
                                                </div>

                                                <div className='col-md-4 col-lg-4'>
                                                    <div className='personaldetails text-justify mt-3'>
                                                        <label htmlFor="productType">Product Type</label><br />
                                                        <input type="number" name="productType" id="productType" value={updatedLoan.productType || ''} onChange={handleChange} placeholder='Product Type' />
                                                    </div>
                                                </div>

                                                <div className='col-md-12 mt-4 mb-5'>
                                                    {hasPermission('Product', 'edit') && (
                                                    <button className='btn btn-primary' onClick={handleUpdate}>Update Loan</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewProduct;
